import local from './environments/local.js';
import production from './environments/production.js';
import staging from './environments/staging.js';
import test from './environments/test.js';
export const featureFlags = {
    local,
    staging,
    production,
    test,
};
//# sourceMappingURL=feature-flags.js.map